export class ProposalOrder {
  constructor(
    public totalRestocking: number,
    public totalInventory: number,
    public totalResearch: number,
    public totalOptionalCost: number,
    public totalProposal: number,
    public restockingCalculation: RestockingCalculation[],
    public inventoryCalculation: InventoryCalculation[],
    public researchingCalculation: ResearchingCalculation[],
    public optionalCalculation: OptionalCalculation[]
  ) { }
}

export class AdditionalCost {
  constructor(
    public id: string,
    public description: string,
    public value: number
  ) { }
}

export class RestockingCalculation {
  constructor(
    public subCategoryId: string,
    public categoryId: string,
    public segmentId: string,
    public tradeMarkId: string,
    public stateId: string,
    public frequencyId: string,
    public subCategoryName: string,
    public hourCost: number,
    public storeCost: number,    
    public restockCost: number,
    public totalVisits: number,
    public storeCount: number,
    public skuCount: number,
    public id: string,
    public subCategoryAdditionalCost: AdditionalCost[],
    public negotiatedValue?: number,
    public suggestHours?: number
  ) { }
}

export class InventoryCalculation {
  constructor(
    public subCategoryId: string,
    public categoryId: string,
    public segmentId: string,
    public tradeMarkId: string,
    public stateId: string,
    public frequencyId: string,
    public subCategoryName: string,
    public hourCost: number,
    public storeCost: number,
    public inventoryCost: number,
    public totalVisits: number,
    public storeCount: number,    
    public skuCount: number,
    public id: string,
    public negotiatedValue?: number,
    public suggestHours?: number,
  ) { }
}

export class ResearchingCalculation {
  constructor(
    public tradeMarkId: string,
    public researchId: string,
    public frequencyId: string,
    public stateId: string,
    public researchName: string,
    public researchCost: number,
    public storeCost: number,
    public skuCount: number,
    public id: string,
    public storeCount: number,
    public negotiatedValue?: number
  ) { }
}

export class OptionalCalculation {
  constructor(
    public optionalId: string,
    public optionalName: string,
    public value: number,
    public id: string,
    public monthlyHours: number
  ) { }
}
export class Proposal {
  constructor(
    public id: string,
    public numeroProposta: string,
    public status: number,
    public customer: {
      customerId: string;
      nome: string;
    },
    public company: {
      companyId: string;
      nome: string;
    },
    public vendors: {
      vendorId: string;
      nome: string;
    }[],
    public discountPercentage: number | null,
    public totalRestocking: number,
    public totalInventory: number,
    public totalResearch: number,
    public totalOptionalCost: number,
    public totalProposal: number,
    public totalFinal: number,
    public proposalRestockings: any[],
    public proposalInventories: any[],
    public proposalsResearches: any[],
    public value: number,
    public proposalOptionalCosts: any[]
  ) { }
}

export class ResearchesViabilitiesOperationStart {
  constructor(
    public proposalResearchStoreId: string,
    public startDate: string,
  ) { }
}

export class InventoryViabilitiesOperationStart {
  constructor(
    public proposalInventoryStoreId: string,
    public startDate: string,
  ) { }
}

export class RestockingViabilitiesOperationStart {
  constructor(
    public proposalRestockingStoreId: string,
    public startDate: string,
  ) { }
}

export class CreateStartOperation {
  constructor(
    public proposalId: string,
    public researchesViabilities: ResearchesViabilitiesOperationStart[],
    public inventoriesViabilities: InventoryViabilitiesOperationStart[],
    public restockingViabilities: RestockingViabilitiesOperationStart[]
  ) { }
}

//Models viability
export class RestockingViability {
  constructor(
    public id: string,
    public necessaryHours: number,
    public skuCount: number,
    public task: string,
    public restockViabilityStores: GenericViabilityStore[]
  ) { }
}
export class ResearchesViability {
  constructor(
    public id: string,
    public necessaryHours: number,
    public skuCount: number,
    public task: string,
    public researchViabilityStores: GenericViabilityStore[]
  ) { }
}
export class InventoriesViability {
  constructor(
    public id: string,
    public necessaryHours: number,
    public skuCount: number,
    public task: string,
    public inventoryViabilityStores: GenericViabilityStore[]
  ) { }
}

export class StoreViability {
  constructor(
    public id: string,
    public storeNumber: string,
    public tradeName: string,
    public state: string,
    public city: string,
    public neighborhood: string,
    public cnpj: string,
    public isActive: boolean,
  ) { }
}

export class GenericViabilityStore {
  constructor(
    public id: string,
    public storeId: string,
    public frequency: {
      frequencyId: string;
      frequency: number;
      frequencyType: number;
    },
    public operationCompany: {
      id: string;
      name: string;
      environmentId: string;
      status: boolean;
    } | null,
    public store: StoreViability,
    public viability: boolean,
    public reasonInfeasibility: string | null,
    public suggestPromoter: string | null,
    public suggestDate: Date | null,
    public startDate: Date | null
  ) { }
}


export class CreateGenericViability {
  constructor(
    public id: string,
    public proposalResearchId: string,
    public operationCompany: {
      id: string;
      name: string;
      environmentId: string;
      status: boolean;
    },
    public storeId: string,
    public viability: boolean,
    public reasonInfeasibility: string,
    public suggestPromoter: string,
    public suggestDate: Date,
    public frequencyId: string
  ) { }
}

export class ArrayCreateGenericViability {
  constructor(
    public researchesViabilities: CreateGenericViability[],
    public inventoriesViabilities: CreateGenericViability[],
    public restockingViabilities: CreateGenericViability[]
  ) { }
}
export class ArrayGetGenericViability {
  constructor(
    public researchesViabilities: ResearchesViability[],
    public inventoriesViabilities: InventoriesViability[],
    public restockViabilities: RestockingViability[]
  ) { }
}

//Models get orderById 

export class Customer {
  constructor(
    public id: string,
    public customerId: string,
    public nome: string
  ) { }
}

export class Company {
  constructor(
    public companyId: string,
    public nome: string
  ) { }
}

export class Vendor {
  constructor(
    public vendorId: string,
    public nome: string
  ) { }
}

export class Info {
  constructor(
    public creationDate: Date,
    public plannedTotal: number,
    public storeCount: number
  ) { }
}

export class SubCategory {
  constructor(
    public sunCategoryId: string,
    public nome: string
  ) { }
}

export class Frequency {
  constructor(
    public frequencyId: string,
    public nome: string
  ) { }
}

export class ProposalRestocking {
  constructor(
    public proposoalRestockingId: string,
    public Subcategory: SubCategory,
    public stateId: string,
    public frequency: Frequency,
    public storeCount: number,
    public storeCost: number,
    public hoursCost: number,
    public skuCount: number,
    public totalVisits: number,
    public restockCost: number,
    public negotiatedValue?: number
  ) { }
}

export class ProposalInventory {
  constructor(
    public proposalInventoryId: string,
    public subCategory: SubCategory,
    public stateId: string,
    public frequency: Frequency,
    public storeCount: number,
    public storeCost: number,
    public hoursCost: number,
    public skuCount: number,
    public totalVisits: number,
    public restockCost: number,
    public negotiatedValue?: number
  ) { }
}

export class ProposalResearch {
  constructor(
    public proposalResearchId: string,
    public researchId: string,
    public frequency: Frequency,
    public storeCount: number,
    public storeCost: number,
    public skuCount: number,
    public researchCost: number,
    public negotiatedValue?: number
  ) { }
}

export class ProposalOptionalCost {
  constructor(
    public proposalOptionalId: string,
    public optionalCostId: string,
    public optionalCost: number
  ) { }
}

export class LegalDocument {
  constructor(
    public id: string,
    public proposalId: string,
    public assignedDate: Date,
    public fileUrl: string,
    public fileName: string,
    public fileStream: any
  ) { }
}
export class ProposalDataById {
  constructor(
    public customer: Customer,
    public company: Company,
    public vendors: Vendor[],
    public discountPercentage: number,
    public totalRestocking: number,
    public totalInventory: number,
    public totalResearch: number,
    public totalOptionalCost: number,
    public totalProposal: number,
    public totalFinal: number,
    public info: Info,
    public proposalRestockings: ProposalRestocking[],
    public proposalInventories: ProposalInventory[],
    public proposalsResearches: ProposalResearch[],
    public proposalOptionalCosts: ProposalOptionalCost[],
    public legalDocuments: LegalDocument[]
  ) { }
}